import { css } from 'emotion'

export const LinkStyles = css`
  text-decoration: none;
  word-break: break-word;
`
